import React from 'react';
import {
    ControlledInputField,
    ControlledInputFieldProps,
} from 'features/offline-reports/support-requests/components/support-requests-modals/components/inputs/controlled-input-field';
import styles from './support-sales-email-inputs.module.scss';
import { EMAIL_INPUT_REGEX } from 'features/offline-reports/support-requests/consts';

export const SupportSalesEmailInput = (props: Partial<ControlledInputFieldProps>) => {
    return (
        <div className={styles.salesInputWrapper}>
            <ControlledInputField
                name="executiveEmail"
                label="Account Executive Email - For Ticket Creation"
                data-testid="request-new-location-sales-email-input"
                asterix
                required
                type="text"
                rules={{
                    pattern: {
                        value: EMAIL_INPUT_REGEX,
                        message: 'Invalid email address',
                    },
                }}
                {...props}
            />
        </div>
    );
};

export const SupportOpportunityUrlInput = (props: Partial<ControlledInputFieldProps>) => {
    return (
        <div className={styles.salesInputWrapper}>
            <ControlledInputField
                name="opportunityUrl"
                label="Opportunity URL"
                data-testid="request-new-location-opportunity-url-input"
                asterix
                required
                type="text"
                maxLength={50}
                {...props}
            />
        </div>
    );
};
